<template>
  <v-card>
    <s-crud
      ref="crud"
      :config="config"
      title="Establecimientos (Plantas de Trabajo)"
      :filter="filter"
      add
      edit
      remove
      @save="save($event)"
      @add="onAdd()"
      @edit="onEdit($event)"
    >
      <template v-slot="props">
        <v-container>
          <v-row dense>
            <v-col cols="12" md="4" class="s-col-form">
              <s-text
                label="Código Establecimiento (SUNAT)*"
                v-model="props.item.EstCode"
                maxlength="4"
              />
            </v-col>
            <v-col cols="12" md="8" class="s-col-form">
              <s-text
                label="Nombre/Descripción*"
                v-model="props.item.EstDescription"
              />
            </v-col>
            <v-col cols="12" md="12" class="s-col-form">
              <s-text label="Dirección*" v-model="props.item.EstAddress" />
            </v-col>
            <v-col cols="12" md="4" class="s-col-form">
              <s-select-generic
                label="Departamento"
                itemvalue="GenHelper"
                v-model="DepartmentUbigeo"
                autocomplete
                full
                :config="configDepartment"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="4" class="s-col-form">
              <s-select-generic
                label="Provincia"
                itemvalue="GenHelper"
                v-model="ProvinceUbigeo"
                autocomplete
                full
                :config="configProvince"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="4" class="s-col-form">
              <s-select-generic
                itemvalue="GenHelper"
                v-model="DistrictUbigeo"
                label="Distrito"
                autocomplete
                full
                :config="configDistrict"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="8" class="s-col-form">
              <s-text
                label="Actividad Económica (Opcional)"
                v-model="props.item.EstEconomicActivity"
                maxlength="100"
              />
            </v-col>
            <v-col cols="12" md="4" class="s-col-form">
              <v-switch
                v-model="props.item.EstIsSCTRRisk"
                label="Es de Riesgo (SCTR)"
                color="red"
                hide-details
                class="mt-0"
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
    </s-crud>
  </v-card>
</template>

<script>
import SText from "@/components/Utils/SText.vue";
import ServiceEstablishment from "@/services/HumanResource/HmnEstablishment";
import _sGeneric from "@/services/General/GenericService";

export default {
  name: "HmnEstablishment",
  components: {
    SText,
  },
  data() {
    return {
      filter: {},
      configDepartment: null,
      configProvince: null,
      configDistrict: null,
      DepartmentUbigeo: null,
      ProvinceUbigeo: null,
      DistrictUbigeo: null,
      config: {
        service: ServiceEstablishment,
        model: {
          EstID: "ID",
          EstIsSCTRRisk: false,
          EstEconomicActivity: null,
        },
        headers: [
          { text: "Código", value: "EstCode" },
          { text: "Nombre/Descripción", value: "EstDescription" },
          { text: "Dirección", value: "EstAddress" },
          { text: "Ubigeo", value: "EstUbigeo" },
          { text: "Riesgo SCTR", value: "EstIsSCTRRisk" },
        ],
      },
    };
  },
  created() {
    this.configDepartment = {
      title: "Departamento",
      url: _sGeneric.getDepartment(),
      params: { requestID: this.$fun.getUserID() },
    };
    this.configProvince = {
      title: "Provincia",
      url: _sGeneric.getProvince(),
      params: { requestID: this.$fun.getUserID(), DepartmentUbigeo: "0" },
    };
    this.configDistrict = {
      title: "Distrito",
      url: _sGeneric.getDistrict(),
      params: { requestID: this.$fun.getUserID(), DistrictUbigeo: "0" },
    };
  },
  watch: {
    DepartmentUbigeo(newVal) {
      if (newVal) {
        this.configProvince = {
          title: "Provincia",
          url: _sGeneric.getProvince(),
          params: { requestID: this.$fun.getUserID(), DepartmentUbigeo: newVal, SearchText: "" },
        };
      }
    },
    ProvinceUbigeo(newVal) {
      if (newVal) {
        this.configDistrict = {
          title: "Distrito",
          url: _sGeneric.getDistrict(),
          params: { requestID: this.$fun.getUserID(), DistrictUbigeo: this.DepartmentUbigeo.toString() + newVal.toString(), SearchText: "" },
        };
      }
    },
  },
  methods: {
    onAdd() {
      this.DepartmentUbigeo = null;
      this.ProvinceUbigeo = null;
      this.DistrictUbigeo = null;
    },
    onEdit(item) {
      if (item && item.EstUbigeo && item.EstUbigeo.length === 6) {
        this.DepartmentUbigeo = item.EstUbigeo.substring(0, 2);
        setTimeout(() => {
          this.ProvinceUbigeo = item.EstUbigeo.substring(2, 4);
          setTimeout(() => {
            this.DistrictUbigeo = item.EstUbigeo.substring(4, 6);
          }, 200);
        }, 200);
      } else {
        this.DepartmentUbigeo = null;
        this.ProvinceUbigeo = null;
        this.DistrictUbigeo = null;
      }
    },
    save(item) {
      if (this.DepartmentUbigeo && this.ProvinceUbigeo && this.DistrictUbigeo) {
        item.EstUbigeo = this.DepartmentUbigeo.toString() + this.ProvinceUbigeo.toString() + this.DistrictUbigeo.toString();
      } else {
        item.EstUbigeo = '';
      }

      if (!item.EstCode || item.EstCode.trim().length === 0) {
        this.$fun.alert("El Código Establecimiento es obligatorio", "warning");
        return;
      }
      if (item.EstCode.trim().length !== 4) {
        this.$fun.alert(
          "El Código Establecimiento debe tener exactamente 4 dígitos",
          "warning",
        );
        return;
      }
      if (!item.EstDescription || item.EstDescription.trim().length === 0) {
        this.$fun.alert("El Nombre/Descripción es obligatorio", "warning");
        return;
      }
      if (!item.EstAddress || item.EstAddress.trim().length === 0) {
        this.$fun.alert("La Dirección es obligatoria", "warning");
        return;
      }
      if (!item.EstUbigeo || item.EstUbigeo.trim().length === 0) {
        this.$fun.alert(
          "El Código Ubigeo es obligatorio (Seleccione Distrito)",
          "warning",
        );
        return;
      }
      if (item.EstUbigeo.trim().length !== 6) {
        this.$fun.alert(
          "El Código Ubigeo debe tener exactamente 6 dígitos (Seleccione Distrito)",
          "warning",
        );
        return;
      }

      // Asegurar el valor booleano
      item.EstIsSCTRRisk = !!item.EstIsSCTRRisk;
      item.save();
    },
  },
};
</script>

<style scoped></style>
